<template>
    <div>
        <header class="header"><div class="container"><h1 class="header__title c--dark">Notifications</h1></div></header>

        <component
            v-for="notification in user.notifications"
            :is="componentNameFromClass(notification.type)"
            :notification="notification"
            :key="notification.id">
        </component>

        <navigation></navigation>
    </div>
</template>

<script>
    import Navigation from "./partial/Navigation";
    import {mapState} from "vuex";

    export default {
        name: "Notifications",
        components: {Navigation},

        computed: {
            ...mapState('auth', [
                'user'
            ])
        },

        mounted() {
            $('body').addClass('body--secondary')

        },

        beforeDestroy() {
            $('body').removeClass('body--secondary')
        }
    }
</script>